/**
 * ERP ingest: lines Riverr could not turn into items. Shared copy for the
 * Needs labels page, the batch station screen and the order page.
 */
export const ERP_REASON_SELLER = "seller_not_mapped";
export const ERP_REASON_ITEM = "item_not_mapped";
export const ERP_REASON_UNITS = "units_per_case_unknown";

const REASON_LABELS = {
  [ERP_REASON_SELLER]: "Seller not mapped",
  [ERP_REASON_ITEM]: "Item not mapped",
  [ERP_REASON_UNITS]: "Units per case unknown",
};

export const erpReasonLabel = (reason) =>
  REASON_LABELS[String(reason || "")] || String(reason || "Unresolved");

/** "6 CS" or "6" */
export const erpQuantityLabel = (line = {}) => {
  const qty = line?.quantity;
  if (qty == null || qty === "") return "";
  const unit = String(line?.unit || "").trim();
  return unit ? `${qty} ${unit}` : String(qty);
};

/** Group open lines by seller for the Needs labels page. */
export const groupErpLinesBySeller = (lines = [], groups = []) => {
  const byKey = new Map();
  (groups || []).forEach((group) => {
    const key = String(group?.sellerExternalId || group?.sellerUid || "");
    if (!key) return;
    byKey.set(key, { ...group, key, lines: [] });
  });
  (lines || []).forEach((line) => {
    const key = String(line?.sellerExternalId || line?.sellerUid || "");
    if (!byKey.has(key)) {
      byKey.set(key, {
        key,
        sellerExternalId: line?.sellerExternalId || "",
        sellerUid: line?.sellerUid || null,
        sellerName: line?.sellerName || "",
        count: 0,
        lines: [],
      });
    }
    byKey.get(key).lines.push(line);
  });
  return [...byKey.values()]
    .map((group) => ({
      ...group,
      count: group.lines.length,
      sellerMissing: group.lines.some(
        (line) => line?.reason === ERP_REASON_SELLER
      ),
    }))
    .filter((group) => group.lines.length > 0)
    .sort((a, b) =>
      String(a.sellerName || a.sellerExternalId).localeCompare(
        String(b.sellerName || b.sellerExternalId)
      )
    );
};

/** "Released ORD2710082 (BSP-261007-014)" style toast copy. */
export const releasedOrdersMessage = (released = [], fallback = "") => {
  const rows = (released || []).filter(Boolean);
  if (!rows.length) return fallback;
  const names = rows.map((row) => {
    const name = row.externalOrderId || row.orderId;
    return row.batchNumber ? `${name} (${row.batchNumber})` : String(name);
  });
  return `Released ${rows.length === 1 ? "order" : `${rows.length} orders`}: ${names.join(
    ", "
  )}`;
};
